import { useCallback } from 'react';

import type { RemoteParticipantWrapperProps } from '../session/session-grid/RemoteParticipantCell';
import { RemoteParticipantWrapper as BaseRemoteParticipant } from '../session/session-grid/RemoteParticipantCellWrapper';
import { type RemoteParticipantMediaEventHandler } from '../video-sdk';
import { useHandleReceivedMessageCallback } from './messages/useHandleReceivedMessageCallback';
import { useSendProviderParticipantStateCallback } from './messages/useSendProviderParticipantStateCallback';
import { useTrackSessionParticipantViewedEvent } from './useTrackSessionParticipantViewedEvent';

export function RemoteParticipant(props: Omit<RemoteParticipantWrapperProps, 'onMessageReceived'>) {
  const handleReceivedMessage = useHandleReceivedMessageCallback();
  useTrackSessionParticipantViewedEvent(props.remoteParticipant.identity);
  const sendParticipantState = useSendProviderParticipantStateCallback();

  const onDataTrackSubscribed: RemoteParticipantMediaEventHandler = useCallback(() => {
    sendParticipantState();
  }, [sendParticipantState]);

  return (
    <BaseRemoteParticipant
      {...props}
      onMessageReceived={handleReceivedMessage}
      onDataTrackSubscribed={onDataTrackSubscribed}
    />
  );
}
